/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import { PopOut, PopOutBody } from '@econsult/econsult-ui/dist/components/PopOut';
import { EndIcon as InputIconContainer } from '@econsult/econsult-ui/dist/components/Input/InputStyles';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { CancelIcon, SearchIcon } from '@econsult/econsult-ui/dist/assets';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { FlexColumnDiv, FlexDiv } from 'components/Div/styles';
import { InvisibleButton } from './buttons';
import { LightInput } from './inputs';

export const ActionPopOut = styled(PopOut)``;

export const ActionPopOutBody = styled(PopOutBody)`
  padding: 0;
  ${({ alignRight }) => alignRight && `
    min-width: 15rem;
    top: 0;
    left: calc(100% + 6px);
  `};
`;

export const ActionPopOutSearchInputWrapper = styled.form`
  padding: 8px;
  background-color: ${({ theme }) => theme.colorBackgroundSoftWhite};
  svg {
    margin: 0;
    width: 1rem;
    height: 1rem;
    color: currentColor;
  }
`;

export const InputButton = styled(Button).attrs({ size: 'small', fillStyle: 'borderless' })`
  padding: 0;
  color: ${({ theme }) => theme.colorNeutralNeutral8};
  border: none;
  cursor: pointer;
`;

interface ActionPopOutSearchClearButtonProps {
  hasSearched: boolean;
  onClear: () => void;
}

export const ActionPopOutSearchClearButton: React.FC<ActionPopOutSearchClearButtonProps> = ({ hasSearched, onClear }) => (
  hasSearched
    ? (
      <InputButton data-automation="CancelSearchButton" onClick={onClear}>
        <CancelIcon />
      </InputButton>
    ) : (
      <SearchIcon />
    )
);

export const ActionPopOutSearchInput = styled(LightInput).attrs({ typography: 'ParagraphTinyRegular' })`
  ${InputIconContainer} {
    display: flex;
    justify-content: center;
    align-items: center;

    --icon-margin: 0.75rem;
  }
`;

export const ActionPopOutTitle = styled(Paragraph).attrs({ typography: 'ParagraphTinyHeavy' })`
  margin: 0;
  color: ${({ theme }) => theme.colorNeutralBlack};
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'pre-wrap')};
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const borderRadiusCurve = '0.375rem';

interface ActionPopOutTitleWrapperProps {
  small?: boolean;
}

export const ActionPopOutTitleWrapper = styled(FlexDiv)<ActionPopOutTitleWrapperProps>`
  align-items: center;
  padding: ${({ small }) => (small ? '0.5rem 0.75rem' : '0.75rem')};
  background: ${({ theme }) => theme.colorBackgroundSoftWhite};
  border-bottom: 1px solid ${({ theme }) => theme.colorNeutralNeutral9};
  border-radius: ${borderRadiusCurve} ${borderRadiusCurve} 0 0;
  justify-content: space-between;
`;

export const ActionPopOutSubTitleWrapper = styled(ActionPopOutTitleWrapper)`
  padding: 0.35rem 0.75rem;
  border-radius: 0;
`;

export const ActionPopOutListItem = styled.button.attrs({ typography: 'ParagraphTinyHeavy' })`
  ${({ theme }) => theme.fontStyles};
  background-color: ${({ theme }) => theme.colorNeutralBrightWhite};
  border: none;
  padding: 18px 24px 18px 12px;
  border-top: 1px solid ${({ theme }) => theme.colorNeutralNeutral9};
  color: ${({ theme }) => theme.colorNeutralBlack};
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  cursor: pointer;
  flex-shrink: 0;
  :hover {
    background: ${({ theme }) => theme.colorNeutralNeutral9};
  }
`;

export const ActionPopOutScrollContainer = styled(FlexColumnDiv)`
  max-height: 16rem;
  overflow-y: scroll;
  border-radius: 0 0 ${borderRadiusCurve} ${borderRadiusCurve};
`;

export const ActionPopOutInvisibleButton = styled(InvisibleButton).attrs({ typography: 'ParagraphTinyHeavy' })`
  display: flex;
  ${({ theme }) => theme.fontStyles};
  align-items: center;
  padding: 0.375rem;
  line-height: 1em;
  color: ${({ theme }) => theme.colorNeutralBlack};

  &:hover {
    background: ${({ theme }) => theme.colorNeutralNeutral8};
  }
`;
